export const FEEDBACK_MAX_LENGTH = 5000;
export const FEEDBACK_RECIPIENT = 'feedback@gatheredinforms.com';
